namespace PaperTrail.NewsletterControl {
    export interface StoryContributorRow {
        StoryId?: number;
        UserId?: number;
        NewsletterId?: number;
        NewslettersList?: number[];
        DateSubmitted?: string;
        DateModified?: string;
        DatePublished?: string;
        Title?: string;
        Subtitle?: string;
        StoryText?: string;
        Position?: number;
        Characters?: number;
        DoPageBreak?: boolean;
        Rows?: number;
        Columns?: number;
        IsPlaced?: boolean;
        StyleSheetId?: number;
        Rank?: number;
        PageTemplateId?: number;
        PageTemplateSectionId?: number;
        StoryBlocks?: StoryTextBlockRow[];
        StoryHighlights?: StoryHighlightRow[];
        StoryImages?: StoryImageRow[];
        StoryAds?: StoryAdvertisementRow[];
        StoryNews?: StoryNewsRow[];
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        NewsletterNewsletterName?: string;
        NewsletterCreatedBy?: number;
        NewsletterDateCreated?: string;
        NewsletterDateModified?: string;
        NewsletterModifiedBy?: number;
        NewsletterPages?: number;
        NewsletterStyleSheetId?: number;
        StyleSheetTitle?: string;
        StyleSheetFont?: string;
        StyleSheetFontSize?: number;
        StyleSheetTextAlignment?: string;
        StyleSheetHeight?: number;
        StyleSheetWidth?: number;
        StyleSheetPadding?: string;
        StyleSheetMargin?: string;
        StyleSheetRows?: number;
        StyleSheetColumns?: string;
        StyleSheetRotation?: number;
        StyleSheetBackgroundColor?: string;
        StyleSheetForeColor?: string;
        StyleSheetIsUnderline?: boolean;
        StyleSheetIsBold?: boolean;
        StyleSheetIsItalic?: boolean;
    }

    export namespace StoryContributorRow {
        export const idProperty = 'StoryId';
        export const nameProperty = 'Title';
        export const localTextPrefix = 'NewsletterControl.StoryContributor';
        export const lookupKey = 'NewsletterControl.StoryContributor';

        export function getLookup(): Q.Lookup<StoryContributorRow> {
            return Q.getLookup<StoryContributorRow>('NewsletterControl.StoryContributor');
        }
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            StoryId = "StoryId",
            UserId = "UserId",
            NewsletterId = "NewsletterId",
            NewslettersList = "NewslettersList",
            DateSubmitted = "DateSubmitted",
            DateModified = "DateModified",
            DatePublished = "DatePublished",
            Title = "Title",
            Subtitle = "Subtitle",
            StoryText = "StoryText",
            Position = "Position",
            Characters = "Characters",
            DoPageBreak = "DoPageBreak",
            Rows = "Rows",
            Columns = "Columns",
            IsPlaced = "IsPlaced",
            StyleSheetId = "StyleSheetId",
            Rank = "Rank",
            PageTemplateId = "PageTemplateId",
            PageTemplateSectionId = "PageTemplateSectionId",
            StoryBlocks = "StoryBlocks",
            StoryHighlights = "StoryHighlights",
            StoryImages = "StoryImages",
            StoryAds = "StoryAds",
            StoryNews = "StoryNews",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            NewsletterNewsletterName = "NewsletterNewsletterName",
            NewsletterCreatedBy = "NewsletterCreatedBy",
            NewsletterDateCreated = "NewsletterDateCreated",
            NewsletterDateModified = "NewsletterDateModified",
            NewsletterModifiedBy = "NewsletterModifiedBy",
            NewsletterPages = "NewsletterPages",
            NewsletterStyleSheetId = "NewsletterStyleSheetId",
            StyleSheetTitle = "StyleSheetTitle",
            StyleSheetFont = "StyleSheetFont",
            StyleSheetFontSize = "StyleSheetFontSize",
            StyleSheetTextAlignment = "StyleSheetTextAlignment",
            StyleSheetHeight = "StyleSheetHeight",
            StyleSheetWidth = "StyleSheetWidth",
            StyleSheetPadding = "StyleSheetPadding",
            StyleSheetMargin = "StyleSheetMargin",
            StyleSheetRows = "StyleSheetRows",
            StyleSheetColumns = "StyleSheetColumns",
            StyleSheetRotation = "StyleSheetRotation",
            StyleSheetBackgroundColor = "StyleSheetBackgroundColor",
            StyleSheetForeColor = "StyleSheetForeColor",
            StyleSheetIsUnderline = "StyleSheetIsUnderline",
            StyleSheetIsBold = "StyleSheetIsBold",
            StyleSheetIsItalic = "StyleSheetIsItalic"
        }
    }
}
